import React from "react";
import { Container, Row, Col } from "reactstrap";

import Highlight from "../components/Highlight";
import Loading from "../components/Loading";
import { BsPersonCircle } from "react-icons/bs";
import { useAuth, withAuthenticationRequired } from "../context/AuthContext";

export const ProfileComponent = () => {
  const { user } = useAuth();

  return (
    <Container className="mb-5">
      <Row className="align-items-center profile-header mb-5 text-center text-md-left">
        <Col md={2}>
          {user.photoURL ? (
            <img
              src={user.photoURL}
              alt="Profile"
              className="rounded-circle img-fluid profile-picture mb-3 mb-md-0"
            />
          ) : (
            <BsPersonCircle size={64} />
          )}
        </Col>
        <Col md>
          <h4>{user.email}</h4>
        </Col>
      </Row>
      <Row>
        <Highlight>{JSON.stringify({ uid: user.uid, email: user.email }, null, 2)}</Highlight>
      </Row>
    </Container>
  );
};

export default withAuthenticationRequired(ProfileComponent, {
  onRedirecting: () => <Loading />,
});
